import React, { useState } from "react";
import { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Layout from "./shared/Layout";
import SigninCallbackView from "./features/Account/views/SigninCallbackView";
import LoginView from "./features/Account/views/LoginView";
import RegisterView from "./features/Account/views/RegisterView";
import HomePage from "./features/main-page/views/MainPage";
import ChangePassword from "./features/main-page/components/SettingPages/ChangePassword";
import ForgetPassword from "./features/Account/components/ForgetPassword";
import ResendEmail from "./features/Account/components/ResendEmail";
import SettingComponent from "./features/main-page/components/get-conversation/SettingComponent";
import Privacy_Policy from "./features/main-page/components/SettingPages/Privacy_Policy";
import TermAndCondition from "./features/main-page/components/SettingPages/TermAndCondition";
import PaymentPage from "./features/main-page/components/get-conversation/PaymentPage";
import ContactUs from "./features/Account/components/ContactUs";
import ResetPassword from "./features/main-page/components/SettingPages/ResetPassword";
import HelpAndSupport from "./features/main-page/components/SettingPages/Help & Support/HelpAndSupport";
import CancelSubscription from "./features/Account/components/CancelSubscription";
import Subscription from "./features/Account/components/Subscription";
import AlertMessage from "./features/main-page/components/get-conversation/AlertMessage";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { fetchBuildTimestamp } from "./clearCache";
import SnackBarAlert from "./features/main-page/components/get-conversation/SnackBarAlert";
import ProtectedRouting from "./ProtectedRouting";
import SignInPopup from "./features/landing-page/components/SignInPopup";
import {
  setMessageErrorLogin,
  setShowPlansModal,
  setShowSignPopup,
} from "./store/one-query/chatsSlice";
import HealthCheck from "./features/Health-check/Views/HealthCheck";
import { UpgradeSubscriptionPlanModal } from "./features/main-page/components/Popups/UpgradeSubscriptionPlanModal";
import { FreeTrialPopup } from "./features/main-page/components/Popups/FreeTrialPopup";
import { useErrorListener } from "./features/one-query/services/EventEmitter";
import MainPromoCode from "./PromoCode/Views/mainPromoCode";
import { CreatePromoCode } from "./PromoCode/CreateNewPromodeod/View/CreatePromoCode";
import { PromoCodeDashboard } from "./PromoCode/Dashboard/View/PromoCodeDashboard";
import { UpdatePromoCode } from "./PromoCode/UpdatePromoCode/Views/UpdatePromoCode";
import {
  ModelsNamesCompany,
  ParameterTypes,
  getPathNameParts,
  metaTags,
  PromoAlertData,
} from "./Helper";
import { useGetAllPromoCodes } from "./store/Apis/StripeApi";
import { ViewPromoCode } from "./PromoCode/ViewPromoCode/View/ViewPromoCode";
import Workflows from "./features/Workflows/Views/Workflows";
import Models from "./features/main-page/components/get-conversation/Models";
import { TextSuites } from "./features/TextSuite/Views/TextSuites";
import { ImageSuite } from "./features/ImageSuite/View/ImageSuite";
import { Suites } from "./features/SharedSuite/Suites";
import RechargeConfirmation from "./features/CreditsScenario/RechargeConfirmation";
import VideoSuite from "./features/VideoSuite/View/VideoSuite";
import WorkflowContainer from "./features/Workflows/Components/WorkflowContainer";
import { SuiteHistoryView } from "./Layouts/SuiteHistoryLayout/View/SuiteHistoryView";
import { TextSuiteHistoryContainer } from "./features/TextSuite/TextSuiteHistory/Layout/TextSuiteHistoryContainer";
import { ImageSuiteHistoryContainer } from "./features/ImageSuite/ImageSuiteHistory/Layout/ImageSuiteHistoryContainer";
import VideoSuiteHistoryContainer from "./features/VideoSuite/VideoSuiteHistory/Layout/VideoSuiteHistoryContainer";
import { useGetAllApps } from "./store/Apis/SuitesApps/TextSuitesApi";
import { setAllTextSuitesApps } from "./store/one-query/workflowsSlice";
import { useGetModelSettingsParameter } from "./store/Apis/ModelSettingsApi";
import { setModelParameters } from "./store/one-query/modelsettings";
import SeoHelmet from "./shared/SeoHelmet";
import InspirationLibrary from "./features/InspirationLibrary/view/InspirationLibrary";
import { VideoLibraryContainer } from "./features/InspirationLibrary/Apps/Video/Components/VideoLibraryContainer";
import { SharedWorkflowView } from "./features/Workflows/ShareWorkflow/View/SharedWorkflowView";
import { ImageLibraryContainer } from "./features/InspirationLibrary/Apps/Image/ImageLibraryContainer";

const App = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  let darkMode = useAppSelector((state) => state.User.darkMode);
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector((s) => s.User.IsAuthenticated);
  const ChatsStore = useAppSelector((s) => s.ChatsState);
  const { data: getAllTextSuitesApps } = useGetAllApps();
  const { data: getAllDefaultParameters } = useGetModelSettingsParameter();
  const [promoAlert, setPromoAlert] = useState<PromoAlertData>({
    show: false,
    headerTitle: "",
    description: "",
    firstAction: "",
    secAction: "",
    alertType: "",
  });
  const workflowRoutes = [
    { path: "/workflows", element: <Workflows /> },
    { path: "/workflows/create-workflow", element: <WorkflowContainer /> },
    { path: "/workflows/:workflowId", element: <Workflows /> },
    { path: "/workflows/edit/:workflowId", element: <WorkflowContainer /> },
    {
      path: "/workflows/share/:workflowRunId",
      element: <SharedWorkflowView />,
    },
  ];

  const libraryRoutes = [
    {
      path: "/library",
      element: <InspirationLibrary />,
      children: [
        { index: true, element: <Navigate to="image" replace /> },
        { path: "image", element: <ImageLibraryContainer /> },
        { path: "video", element: <VideoLibraryContainer /> },
      ],
    },
  ];

  const suiteRoutes = [
    {
      path: "/suites",
      element: <Suites />,
      children: [
        { index: true, element: <Navigate to="text-suite" replace /> },
        { path: "text-suite", element: <TextSuites /> },
        { path: "image-suite", element: <ImageSuite /> },
        { path: "video-suite", element: <VideoSuite /> },
      ],
    },
  ];
  useEffect(() => {
    if (getAllDefaultParameters) {
      const objData = getAllDefaultParameters?.settingsItems?.reduce(
        (result: any, obj: any) => {
          const key =
            ModelsNamesCompany[obj?.modelName.toLowerCase()] +
            " & " +
            obj.modelTitle;
          const parmeterValues: ParameterTypes = {
            temperature: obj?.temperature,
            temperatureCurrentValue: obj?.temperatureCurrentValue,
            temperatureMaxValue: obj?.temperatureMaxValue,
            temperatureMinValue: obj?.temperatureMinValue,
            maxToken: obj?.maxToken,
            maxTokenCurrentValue: obj?.maxTokenCurrentValue,
            maxTokenMaxValue: obj?.maxTokenMaxValue,
            maxTokenMinValue: obj?.maxTokenMinValue,
            topP: obj?.topP,
            topPCurrentValue: obj?.topPCurrentValue,
            topPMaxValue: obj?.topPMaxValue,
            topPMinValue: obj?.topPMinValue,
            frequency: obj?.frequency,
            frequencyCurrentValue: obj?.frequencyCurrentValue,
            frequencyMaxValue: obj?.frequencyMaxValue,
            frequencyMinValue: obj?.frequencyMinValue,
            presencePenalty: obj?.presencePenalty,
            presencePenaltyCurrentValue: obj?.presencePenaltyCurrentValue,
            presencePenaltyMaxValue: obj?.presencePenaltyMaxValue,
            presencePenaltyMinValue: obj?.presencePenaltyMinValue,
          };
          // Push an object with a single key-value pair into the result array
          result.push({ [key]: parmeterValues });
          return result;
        },
        [] as Array<Record<string, ParameterTypes>>
      );
      dispatch(setModelParameters(objData));
    }
  }, [getAllDefaultParameters]);

  useEffect(() => {
    if (getAllTextSuitesApps)
      dispatch(setAllTextSuitesApps(getAllTextSuitesApps));
  }, [getAllTextSuitesApps]);
  useEffect(() => {
    fetchBuildTimestamp();
  }, []);
  useEffect(() => {
    if (ChatsStore.showPlansModal) navigate("/subscription-plans");
  }, [ChatsStore.showPlansModal]);

  useEffect(() => {
    if (window.location.pathname === "/subscription-plans")
      dispatch(setShowPlansModal(true));
  }, [window.location.pathname]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
      document.querySelector("body")?.setAttribute("color-theme", "dark");
    } else {
      document.body.classList.remove("dark");
      document.querySelector("body")?.setAttribute("color-theme", "light");
    }
  }, [darkMode]);

  const handleCloseSignInPopup = () => {
    dispatch(
      setShowSignPopup({ show: false, type: "", message: "", btnTitle: "" })
    );
  };

  useErrorListener((message: string, status: number, errorMessage: string) => {
    if (errorMessage) {
      dispatch(setMessageErrorLogin(errorMessage));
    }
  });
  const pageTitle = getPathNameParts(pathname);

  return (
    <>
      <SeoHelmet title={pageTitle} metaTags={metaTags} />
      {ChatsStore.freeTrialMessage?.show && (
        <FreeTrialPopup
          show={ChatsStore.freeTrialMessage?.show}
          title={ChatsStore.freeTrialMessage?.title}
          desc={ChatsStore.freeTrialMessage?.description}
          btnTitle={ChatsStore.freeTrialMessage?.btnTitle}
          isError={ChatsStore.freeTrialMessage?.isError}
        />
      )}
      {ChatsStore.fileErrorMsg.isError && (
        <AlertMessage
          showAlert={ChatsStore.fileErrorMsg.isError}
          message={ChatsStore.fileErrorMsg.errorMsg}
        />
      )}
      {ChatsStore.snackAlert.show && (
        <SnackBarAlert
          showSnackBar={ChatsStore.snackAlert.show}
          snackBarMessage={ChatsStore.snackAlert.message}
          snackType={ChatsStore.snackAlert.alertType}
          snackMessageBody={ChatsStore.snackAlert.messageBody}
          position={ChatsStore.snackAlert.position}
        />
      )}
      {ChatsStore.showSignPopup.show && (
        <SignInPopup
          show={ChatsStore.showSignPopup.show}
          handleClose={handleCloseSignInPopup}
          type={ChatsStore.showSignPopup.type}
          message={ChatsStore.showSignPopup.message}
          btnTitle={ChatsStore.showSignPopup.btnTitle}
          btnAction={ChatsStore.showSignPopup.btnAction}
        />
      )}
      <Routes>
        {!isAuthenticated && (
          <Route path="/" element={<HomePage />}>
            {workflowRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}

            {suiteRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element}>
                {route.children?.map((child, childIndex) => (
                  <Route
                    key={childIndex}
                    path={child.path}
                    element={child.element}
                    index={child.index}
                  />
                ))}
              </Route>
            ))}
            {libraryRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element}>
                {route.children?.map((child, childIndex) => (
                  <Route
                    key={childIndex}
                    path={child.path}
                    element={child.element}
                    index={child.index}
                  />
                ))}
              </Route>
            ))}
          </Route>
        )}
        <Route path="/account/login" element={<LoginView />} />
        <Route path="/account/register" element={<RegisterView />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/resend-email" element={<ResendEmail />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/health-check" element={<HealthCheck />} />
        <Route element={<ProtectedRouting />}>
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/privacy-policy" element={<Privacy_Policy />} />
          <Route path="/term-condition" element={<TermAndCondition />} />
          <Route
            path="/Credit/checkout-completed"
            element={<RechargeConfirmation />}
          />
          <Route element={<Layout />}>
            {isAuthenticated && (
              <Route path="/" element={<HomePage />}>
                <Route index element={<Models page="Main-page" />} />
                <Route
                  path="/conversation/:id"
                  element={<Models page="Main-page" />}
                />
                <Route
                  path="/subscription-plans"
                  element={<UpgradeSubscriptionPlanModal />}
                />
                {workflowRoutes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}

                {suiteRoutes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element}>
                    {route.children?.map((child, childIndex) => (
                      <Route
                        key={childIndex}
                        path={child.path}
                        element={child.element}
                        index={child.index}
                      />
                    ))}
                  </Route>
                ))}
                {libraryRoutes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element}>
                    {route.children?.map((child, childIndex) => (
                      <Route
                        key={childIndex}
                        path={child.path}
                        element={child.element}
                        index={child.index}
                      />
                    ))}
                  </Route>
                ))}
                <Route path="/suites/history" element={<SuiteHistoryView />}>
                  <Route path="text" element={<TextSuiteHistoryContainer />} />
                  <Route
                    path="image"
                    element={<ImageSuiteHistoryContainer />}
                  />
                  <Route
                    path="video"
                    element={<VideoSuiteHistoryContainer />}
                  />
                </Route>
              </Route>
            )}
            <Route path="/settings" element={<SettingComponent />} />
            <Route path="/conversation/:id" element={<HomePage />} />
            <Route path="/signin-oidc" element={<SigninCallbackView />} />
            <Route path="/upgradeToPro" element={<PaymentPage />} />
            <Route path="/help-and-support" element={<HelpAndSupport />} />
            <Route
              path="/Cancel-subscription"
              element={<CancelSubscription />}
            />
            <Route
              path="/cancel-my-Subscription"
              element={<CancelSubscription />}
            />
            <Route path="/subscription" element={<Subscription />} />
            <Route
              path="/admin/manage-coupons"
              element={
                <MainPromoCode
                  promoAlert={promoAlert}
                  setPromoAlert={setPromoAlert}
                />
              }
            >
              <Route
                index
                element={
                  <PromoCodeDashboard
                    promoAlert={promoAlert}
                    setPromoAlert={setPromoAlert}
                  />
                }
              ></Route>
              <Route
                path="create-coupon"
                element={
                  <CreatePromoCode
                    promoAlert={promoAlert}
                    setPromoAlert={setPromoAlert}
                  />
                }
              ></Route>
              <Route path="update-coupon" element={<UpdatePromoCode />}></Route>
              <Route path="view-coupon/:id" element={<ViewPromoCode />}></Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default App;